
import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      setSubmitMessage('请输入邮箱地址');
      return;
    }

    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('email', email);
      
      const response = await fetch('https://readdy.ai/api/form/d36rc93tg2u3f2oj404g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString()
      });

      if (response.ok) {
        setSubmitMessage('感谢订阅！我们会将最新的轻松生活资讯发送给您。');
        setEmail('');
      } else {
        setSubmitMessage('订阅失败，请稍后重试。');
      }
    } catch (error) {
      setSubmitMessage('订阅失败，请稍后重试。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-[#847eba]/5 to-[#a3c1c3]/5">
      <div className="max-w-4xl mx-auto px-6 lg:px-32 text-center">
        <div className="mb-6 lg:mb-8">
          <img 
            src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/328cc146a9896c01e8700b5c03125333.png"
            alt="哈乐猴邀请"
            className="w-24 lg:w-32 h-24 lg:h-32 mx-auto object-contain mb-4 lg:mb-6"
          />
        </div>

        <h2 className="text-2xl lg:text-4xl font-light text-gray-800 mb-4 lg:mb-6">
          加入轻松计划
        </h2>
        
        <p className="text-sm lg:text-lg text-gray-600 font-light mb-8 lg:mb-12 max-w-2xl mx-auto">
          与哈乐猴一起，开启轻松愉悦的轻盈之旅，获取最新的轻生活资讯
        </p>

        <form 
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="max-w-md mx-auto"
        >
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              className="flex-1 px-4 lg:px-6 py-3 lg:py-4 rounded-full border border-gray-200 focus:border-[#847eba] focus:outline-none focus:ring-2 focus:ring-[#847eba]/20 transition-all duration-300 text-xs lg:text-sm"
              required
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 lg:px-8 py-3 lg:py-4 bg-[#847eba] text-white rounded-full hover:bg-[#6b5d9a] transition-colors duration-300 text-xs lg:text-base font-medium whitespace-nowrap cursor-pointer disabled:opacity-50"
            >
              {isSubmitting ? '订阅中...' : '立即订阅'}
            </button>
          </div>
          
          {submitMessage && (
            <p className={`mt-4 text-xs lg:text-sm ${submitMessage.includes('感谢') ? 'text-green-600' : 'text-red-600'}`}>
              {submitMessage}
            </p>
          )}
        </form>

        <p className="text-xs text-gray-500 mt-4 lg:mt-6 font-light">
          我们承诺保护您的隐私，只分享有价值的轻松生活内容
        </p>
      </div>
    </section>
  );
}
